module.exports = __webpack_public_path__ + "img/liang_normal.775710a6.png";